window.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.truncated-content-readmore').forEach(el => {
        const isTextClamped = elm => elm.scrollHeight > elm.clientHeight
        const readMoreBtn = el.parentElement.querySelector('#btn-read-more');

        if (!isTextClamped(el)) {
            readMoreBtn.remove();
        } else {
            readMoreBtn.addEventListener('click', (e) => {
                e.preventDefault();

                if (el.classList.contains('expanded')) {
                    readMoreBtn.innerText = "Read more..."
                    el.classList.remove('expanded');
                } else {
                    el.classList.add('expanded');
                    readMoreBtn.innerText = "Read less..."
                }
            });
        }
    });
});
